function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26,15.25 L7.85,15.25 L15.42,7.88 C15.6190091,7.58995349 15.5897035,7.20056873 15.3495235,6.94357617 C15.1093435,6.68658361 14.7228281,6.63103982 14.42,6.81 L5.84,15.11 C5.59985003,15.341795 5.46421016,15.6612323 5.46421016,15.995 C5.46421016,16.3287677 5.59985003,16.648205 5.84,16.88 L14.37,25.19 C14.6728281,25.3689602 15.0593435,25.3134164 15.2995235,25.0564238 C15.5397035,24.7994313 15.5690091,24.4100465 15.37,24.12 L7.85,16.75 L26,16.75 C26.4142136,16.75 26.75,16.4142136 26.75,16 C26.75,15.5857864 26.4142136,15.25 26,15.25 Z",
  id: "path-1"
});

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.1rem",
    height: "1rem",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ArrowLeft.4f81a295.svg";
export { ForwardRef as ReactComponent };